/* unplugin-vue-components disabled */import script from "./like.vue?vue&type=script&setup=true&lang=js"
export * from "./like.vue?vue&type=script&setup=true&lang=js"

import "./like.vue?vue&type=style&index=0&id=41bf3164&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41bf3164"]])

export default __exports__